import { Component, OnInit, Input } from '@angular/core';
import { CampaignService } from '../../services/campaign.service';
import { FormService } from '../../services/form.service';
import { ActivatedRoute } from '@angular/router';
import { Campaign } from '../../shared/campaign/campaign.model';
import { Form } from '../../shared/form/form.model';
import { FormGroup, FormControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { t } from '@angular/core/src/render3';

@Component({
  selector: 'app-campaign-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class CampaignDetailComponent implements OnInit {
  public data: any;
  public forms: any;
  // public forms:Form[];

  public rowsOnPage: number = 20;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";

  public campaign: Campaign = new Campaign();
  form: Form = new Form();
  private campaignId: string;
  public leads: number = 0;
  public callRate: number = 0;
  public conversionRate: number = 0;
  public contactability: number = 0;
  public saleRate: number = 0;
  public averageSpeedOfAnswer: number = 0;
  public waste: number = 0;
  public startDate: string;
  public endDate: string;
  public cpl: number = 0;
  public formType: any = { web: true, facebook: false, campaign: false }
  public assignment: FormGroup;
  public admins: any = [];
  public arrayCampos: any = [];
  public role: string = "";
  public formId: string = "";
  public event: any;
  public field = { displayName: "", name: "" };
  public splitAssig: any = [];
  public selectAll: boolean = false;

  constructor(private campaignService: CampaignService, private route: ActivatedRoute, private formService: FormService, private userService: UserService, private authService: AuthService) {
    this.campaignId = this.route.snapshot.params.id;
    this.assignment = new FormGroup({
      type: new FormControl()
    });
    this.role = JSON.parse(localStorage.getItem('user')).data.role;
  }

  getCampaign() {
    this.campaignService.getCampaign(this.campaignId)
      .subscribe((res: any) => {
        this.campaign = this.campaign.deserialize(res.data);
        this.startDate = this.campaign.startDate ? new Date(this.campaign.startDate).toLocaleDateString() : "";
        this.endDate = this.campaign.endDate ? new Date(this.campaign.endDate).toLocaleDateString() : "";
      });
  }

  getForms() {
    this.formService.getFormsByCampaign(this.campaignId)
      .subscribe((res: any) => {
        this.forms = res.data;
        // let form = new Form().deserialize(res.data);
        // this.campaign.forms.push(form);
      })
  }

  toggleAll() {
    for (let user of this.admins) {
      user.checked = this.selectAll;
      const target = { target: user };
      this.assign(target, user._id);
    }
    console.log(this.admins);
  }


  getFormById(formId) {
    // var defered= $q.defer();
    // var promise= defered.promise;


    this.formService.getForm(formId)
      .subscribe((response: any) => {
        this.form = response.data;
        this.checkAssignment();

        //	defered.resolve(this.form)
      }, (err: any) => {
        if (err.status === 401) {
          this.authService.logout();
        }
      });



  }



  getUsersByRole() {
    let clientId = JSON.parse(localStorage.getItem('campaign')).client;
    this.userService.getUsersByClient({ client: clientId })
      .subscribe((response: any) => {
        this.admins = response.data;
      })
  }

  loadForm(data: any) {
    let form = data;
    localStorage.setItem('campaign', JSON.stringify(this.campaign));
    localStorage.setItem('form', JSON.stringify(form));
  }

  isEmpty(value: any) {
    return value != "" && value != undefined && value != null;
  }

  createForm() {
    let body: any
    body = this.form;
    delete body["_id"];
    body.fields = this.arrayCampos;
    let fieldsShow = []
    let form = {}
    this.formService.create(body)
      .subscribe((response: any) => {
        if (response.success === true) {
          this.getForms();
          form = "<form id='" + response.data.web_id + "'";
          ((document.querySelector("#effect-13").parentElement.parentElement).parentElement).classList.remove('md-show');
          this.form.fields.forEach(ele => {
            let input = "<input name='" + ele.name + "'/>"
            form += input;

          })
          form += "/>"
        } else {
        }
      })
  }

  save() {
    if (this.formId !== "") {
      let body = {};
      this.form["form_id"] = this.form._id;
      Object.keys(this.form).map(key => {
        if (key != "_id") {
          body[key] = this.form[key];
        }
      });
      let remove = 0;
      this.admins.forEach(element => {

        this.form.assignment.forEach(user => {
          if (element._id == user.user) {
            if (!element.checked)
              this.form.assignment.splice(remove, 1)

          }
          remove++;

        });
        remove = 0;

      });
      this.formService.update(body, this.formId)
        .subscribe((data: any) => {
          if (data.success === true) {
            this.getForms();
            document.querySelector("#" + this.event).classList.remove('md-show');
          } else {
            console.log(data.message);
          }
        }, (error) => { console.log(error) })
    } else {
      this.form.author = JSON.parse(localStorage.getItem('user')).data.id;
      this.form.campaign = this.campaignId;
      this.form.web_id = Date.now().toString();
      this.form.fb_id = this.formType.facebook ? this.form.fb_id : "";
      this.form.campaign_id = this.formType.campaign ? this.form.campaign_id : "";
      this.form.random_assignment = this.form.random_assignment.toString();
      this.createForm();
    }
  }

  resetSplitData() {
    this.form.splitAssigment = this.form.random_assignment;
    this.form.listOfSplitAssigment = [];
  }

  assignSplit(event, userId) {
    let target = event.target;
    if (target.checked == true) {
      this.form.listOfSplitAssigment.push({ status: "new", user: userId });
    } else {
      let remove = 0;
      this.form.listOfSplitAssigment.forEach(element => {
        if (element.user == userId) {
          this.form.listOfSplitAssigment.splice(remove, 1);

        }
        remove++
      });
    }
  }

  getSplitChecked(userId) {
    const id = this.form.listOfSplitAssigment.find(object => {
      return object.user === userId;
    });

    if (id !== undefined && id !== null) {
      return true;
    }
    return false;
  }

  assign(event, userId) {
    let target = event.target;
    if (target.checked == true) {
      this.form.assignment.push({ status: "new", user: userId });
      this.admins.forEach(element => {
        if (element._id == userId) {
          element.checked = true;
        }
      });
      // this.admins = this.admins.filter(element => {
      // 	console.log("element"+element._id)
      // 	console.log("user"+userId)
      // 	console.log(this.admins)

      // 	if (element._id == userId) {
      // 		element.checked = true;
      // 	}
      // 	console.log(element)
      // 	return element;
      // })
    } else {
      //console.log(this.form.assignment)
      let remove = 0;
      this.form.assignment.forEach(element => {

        if (element.user == userId) {
          //console.log("iguale")
          //this.form.assignment.splice(remove,1);

        }
        remove++
      });
      //console.log(this.form.assignment)
      remove = 0
      this.admins.forEach(element => {
        if (element._id == userId) {
          element.checked = false;

        }
      });
      // this.form.assignment = this.form.assignment.filter(element => {
      // 	if (element.user != userId) return element;
      // });
      // this.admins = this.admins.filter(element => {
      // 	if (element._id == userId) {
      // 		element.checked = false;
      // 	}

      // 	return element;
      // })
    }
    //this.selectAll = this.admins.every(user => user.checked);
  }

  checkAssignment() {
    this.admins = this.admins.filter(user => {
      user.checked = false;
      for (let i = 0; i < this.form.assignment.length; i++) {
        let element = this.form.assignment[i];

        if (user._id == element.user) {
          user.checked = true;
          break;
        }
      }

      return user;
    });
  }

  ngOnInit() {
    this.getCampaign();
    this.getForms();
    this.getUsersByRole();
    this.initCampsNew();
  }
  initCampsNew() {
    this.arrayCampos = [];
    let phone = new Field("Telefono", "phone");
    let email = new Field("Correo", "email");
    let name = new Field("Nombre", "name");
    this.arrayCampos.push(phone);
    this.arrayCampos.push(email);
    this.arrayCampos.push(name);
  }
  openMyModal(event, formId = null) {
    document.querySelector("#" + event).classList.add('md-show');
    this.event = event;
    if (formId !== null) {
      this.formService.getForm(formId)
        .subscribe((response: any) => {
          this.form = response.data;
          this.formId = formId
          if (this.form.fields.length != 0) {
            this.arrayCampos = this.form.fields
          } else {
            this.initCampsNew();
          }
          this.checkAssignment();
          if(this.form.campaign_id){
            this.formType.campaign = true; // Check campaign checkbox.
          }

          //	defered.resolve(this.form)
        }, (err: any) => {
          if (err.status === 401) {
            this.authService.logout();
          }
        });




      //this.getFormById(formId);





    } else {
      this.formId = "";
      this.form = new Form();
    }
  }

  closeMyModal(event) {
    ((event.target.parentElement.parentElement).parentElement).classList.remove('md-show');
  }
  addCampo() {
    if (this.field.displayName != "" && this.field.name != "") {
      let field = new Field(this.field.displayName, this.field.name)

      this.arrayCampos.push(field)
      this.field.displayName = "";
      this.field.name = "";
    } else {
      alert("no deje campos vacios")
    }
  }
}
class Field {
  public displayName;
  public name;
  constructor(mostrar, original) {
    this.displayName = mostrar;
    this.name = original
  }
}



// WEBPACK FOOTER //
// ./src/app/components/detail/detail.component.ts